import {
  Injectable
} from '@angular/core';

import {
  StateNode
} from 'microedge-rxstate/dist';

import {
  ChecklistStateModel
} from './checklist-state.model';

import {
  ChecklistStateDispatcher
} from './checklist-state.rxstate';

import {
  ListViewChecklistItemsOrchestrator
} from './items/items.orchestrator';


export class ChecklistState extends StateNode<ChecklistStateModel> {
  constructor(initialState: ChecklistStateModel, dispatcher: ChecklistStateDispatcher) {
    super(initialState, dispatcher);

    this.register('items', ListViewChecklistItemsOrchestrator)
      .begin();
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChecklistStateModel, },
{type: ChecklistStateDispatcher, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
